import { render, staticRenderFns } from "./StudentCompletion.vue?vue&type=template&id=073227ac&scoped=true"
import script from "./StudentCompletion.vue?vue&type=script&lang=js"
export * from "./StudentCompletion.vue?vue&type=script&lang=js"
import style0 from "./StudentCompletion.vue?vue&type=style&index=0&id=073227ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073227ac",
  null
  
)

export default component.exports